<template>
    <div>
        <div v-if="!hasShippingInfo">
            <p class="text-center">尚無寄送資訊</p>
            <div class="d-flex justify-content-center">
                <el-button class="is-round" @click="openShippingInfoDialog">立即填寫</el-button>
            </div>
        </div>
        <div v-else>
            <div class="d-flex">
                <div>
                    <h5>{{ shippingInfo.name }}</h5>
                    <p>{{ shippingInfo.phone }}</p>
                    <p>{{ `${shippingInfo.city}${shippingInfo.district}${shippingInfo.address}` }}</p>
                </div>
                <div class="w-100 d-flex justify-content-end">
                    <a href="#" class="link-primary text-decoration-none" @click="openShippingInfoDialog">編輯 <BaseIcon name="pen-to-square" /></a>
                </div>
            </div>
        </div>
        <!-- 寄送資訊彈窗 -->
        <el-dialog title="寄送資訊" :visible.sync="shippingInfoVisible" :top="'0'" :append-to-body="true">
            <el-form :model="shippingInfo" :rules="shippingInfoRule">
                <el-checkbox :disabled="guestCheck" v-model="syncAddress" @change="applyAddress">套用會員資料</el-checkbox>
                <el-form-item prop="name" label="姓名">
                    <el-input v-model="shippingInfo.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="聯絡電話">
                    <el-input v-model="shippingInfo.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item prop="city" label="選擇縣市">
                    <el-select v-model="shippingInfo.city">
                        <el-option v-for="(city, index) in cities" :key=index :label="city.name"
                            :value="city.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="district" label="選擇區域">
                    <el-select v-model="shippingInfo.district" :disabled="shippingInfo.city === ''">
                        <el-option v-for="district in districts" :key="district.zip" :label="district.name"
                            :value="district.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="address" label="詳細地址">
                    <el-input v-model="shippingInfo.address" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="display: flex; justify-content: space-between;">
                <el-button round @click="shippingInfoVisible = false" style="width: 48%;">取 消</el-button>
                <el-button round type="primary" @click="saveAddress" style="width: 48%;">儲 存</el-button>
            </div>
            <div role="tw-city-selector"></div>
        </el-dialog>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import twCities from '../../../twCities.json'

export default {
    props: {
        memberInfo: {
            type: Object,
            default: () => {},
        },
        tempShippingInfo: {
            type: Array,
            default: () => [],
        },
        guestCheck: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            shippingInfoVisible: false,
            memberInfoClone: {},
            shippingInfo: {
                name: '',
                phone: '',
                city: '',
                district: '',
                address: '',
                postcode: ''
            },
            syncAddress: false,
        }
    },
    computed: {
        hasShippingInfo() {
            const result = this.shippingInfo.city ? true : false
            return result
        },
        cities() {
            return twCities
        },
        districts() {
            const selectCity = this.shippingInfo.city
            if (selectCity !== '') {
                const data = this.cities.find(city => city.name === selectCity)
                if (data) {
                    return data.districts
                }
            }
            return []
        },
        shippingInfoRule() {
            return {
                name: [{
                    required: true,
                    message: '請輸入姓名'
                }],
                phone: [{
                    required: true,
                    message: '請填寫手機號碼',
                    trigger: 'blur',
                },
                {
                    pattern: /^09\d{8}$/,
                    message: '格式請符合 09XXXXXXXX',
                    trigger: 'blur',
                },],
                city: [{
                    required: true,
                    message: '請選擇縣市',
                    // trigger: 'change',
                },],
                district: [{
                    required: true,
                    message: '請選擇區域',
                    trigger: 'blur',
                },],
                address: [{
                    required: true,
                    message: '請輸入地址',
                    trigger: 'blur',
                },],
            }
        }
    },
    methods: {
        openShippingInfoDialog() {
            this.shippingInfoVisible = true
        },
        initShippingInfo() {
            this.shippingInfo = {
                name: '',
                phone: '',
                city: '',
                district: '',
                address: '',
                postcode: ''
            }
        },
        saveAddress() {
            const shippingData = cloneDeep(this.shippingInfo)
            this.$emit('save-address', { shippingInfo: shippingData, syncAddress: this.syncAddress })
            this.shippingInfoVisible = false
        },
        applyAddress() {
            if(!this.guestCheck) {
                let memberInfo = cloneDeep(this.memberInfo.shippingInfo[0])
                memberInfo.phone = memberInfo.phone.replace(/^\+\d+-/, "")
                this.shippingInfo = memberInfo
            }
        }
    },
    created() {
        this.memberInfoClone = cloneDeep(this.memberInfo)
        if(this.tempShippingInfo[0]) {
            this.shippingInfo = this.tempShippingInfo[0]
        }
    }
}
</script>